import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  props: {
    src: {
      type: String,
      default: ""
    },
    compress: {
      type: Number,
      default: 1
    },
    aspectRatio: {
      type: Number,
      default: NaN
    }
  },
  data() {
    return {
      crop: null
    };
  },
  watch: {
    aspectRatio(val) {
      this.crop.setAspectRatio(val);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.crop = new Cropper(this.$refs.img, {
        viewMode: 2,
        dragMode: 'move',
        responsive: false,
        aspectRatio: this.aspectRatio,
        preview: this.$refs.preview
      });
    },
    setAspectRatio(aspectRatio) {
      this.crop.setAspectRatio(aspectRatio);
    },
    getCropData(cb, type = 'image/jpeg') {
      cb(this.crop.getCroppedCanvas().toDataURL(type, this.compress));
    },
    getCropBlob(cb, type = 'image/jpeg') {
      this.crop.getCroppedCanvas().toBlob(blob => {
        cb(blob);
      }, type, this.compress);
    },
    getCropFile(cb, fileName = 'fileName.jpg', type = 'image/jpeg') {
      this.crop.getCroppedCanvas().toBlob(blob => {
        let file = new File([blob], fileName, {
          type: type
        });
        cb(file);
      }, type, this.compress);
    }
  }
};